module.exports = __webpack_public_path__ + "static/ferrarosmallad.2f57e154.jpg";